<template>
  <div class="site-wrapper">
    <Header />
    <main>
      <h1>Statistik över kontaktmetoder</h1>
      <p class="body">
        Diagrammet visar procentuellt hur många som rankat respektive
        kontaktmetod som nummer 1 i enkäten.
      </p>
      <div class="filters">
        <div class="filter-container">
          <label for="age">Välj ålder</label>
          <select id="age" v-model="age">
            <option value="10">10</option>
            <option value="11">11</option>
            <option value="12">12</option>
            <option value="13">13</option>
            <option value="14">14</option>
            <option value="15">15</option>
            <option value="16">16</option>
            <option value="17">17</option>
          </select>
        </div>
        <div class="filter-container">
          <label>Välj startdatum</label>
          <g-date-picker
            v-model="startDate"
            :input-props="{
              class: 'date-input',
              placeholder: 'Startdatum',
              readonly: true
            }"
          />
        </div>
        <div class="filter-container">
          <label>Välj slutdatum</label>
          <g-date-picker
            v-model="endDate"
            :input-props="{
              class: 'date-input',
              placeholder: 'Startdatum',
              readonly: true
            }"
          />
        </div>
      </div>
      <apexcharts
        type="bar"
        height="550"
        :options="chartOptions"
        :series="getTopContactDataSeriesByAge(age, startDate, endDate)"
      ></apexcharts>
    </main>
    <Footer />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';

import apexcharts from 'vue-apexcharts';

import Footer from '@/components/Footer.vue';
import Header from '@/components/Header.vue';
export default {
  components: {
    Footer,
    Header,
    apexcharts
  },
  data() {
    return {
      rawData: [],
      dataLoaded: false,
      age: 10,
      startDate: new Date('2020-05-18'),
      endDate: new Date(),
      chartOptions: {
        chart: {
          type: 'bar',
          height: 550,
          width: '100%'
        },
        plotOptions: {
          bar: {
            horizontal: false
          }
        },
        legend: {
          show: true,
          showForSingleSeries: true,
          fontSize: '18px'
        },
        dataLabels: {
          enabled: true,
          formatter: (val, opts) => {
            return val + ' %';
          },
          style: {
            fontSize: '18px'
          }
        },
        yaxis: {
          labels: {
            style: {
              fontSize: '18px'
            }
          },
          title: {
            text: 'Procent',
            style: {
              fontSize: '18px'
            }
          }
        },
        xaxis: {
          labels: {
            style: {
              fontSize: '18px'
            }
          },
          title: {
            text: 'Kontaktmetod',
            style: {
              fontSize: '18px'
            }
          }
        }
      }
    };
  },
  computed: {
    ...mapGetters({
      getTopContactDataSeriesByAge: 'stats/getTopContactDataSeriesByAge'
    })
  },
  created() {
    this.$store.dispatch('stats/load').then(response => {
      this.rawData = response;
      this.dataLoaded = true;
    });
  }
};
</script>

<style lang="scss">
.body {
  margin-bottom: 60px;
}

label {
  display: block;
  font-weight: 600;
}

select {
  border: 1px solid $orange;
  font-size: 18px;
  height: 45px;
  max-width: 500px;
  padding: 5px 10px;
  width: 100%;
}

.filters {
  align-items: flex-end;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  margin-bottom: 40px;
}

.filter-container {
  margin-right: 50px;
}

.date-input {
  font-size: 18px;
  height: 45px;
  max-width: 500px;
}
</style>
